import { lazy } from 'react';

const Invoices = lazy(() =>
  import('pages/ManagerInvoices').then((module) => ({
    default: module.ManagerInvoices,
  }))
);

const ManagerAppointments = lazy(() =>
  import('pages/ManagerAppointments').then((module) => ({
    default: module.ManagerAppointments,
  }))
);

const ManagerAuth = lazy(() =>
  import('pages/ManagerAuth').then((module) => ({
    default: module.ManagerAuth,
  }))
);

const ManagerCampaigns = lazy(() =>
  import('pages/ManagerCampaigns').then((module) => ({
    default: module.ManagerCampaigns,
  }))
);

const ManagerContractors = lazy(() =>
  import('pages/ManagerContractors').then((module) => ({
    default: module.ManagerContractors,
  }))
);

const ManagerCreatePassword = lazy(() =>
  import('pages/ManagerCreatePassword').then((module) => ({
    default: module.ManagerCreatePassword,
  }))
);

const ManagerLeads = lazy(() =>
  import('pages/ManagerLeads').then((module) => ({
    default: module.ManagerLeads,
  }))
);

const ManagerSales = lazy(() =>
  import('pages/ManagerSales').then((module) => ({
    default: module.ManagerSales,
  }))
);

const ManagerPasswordRecovery = lazy(() =>
  import('pages/ManagerPasswordRecovery').then((module) => ({
    default: module.ManagerPasswordRecovery,
  }))
);

const ManagerGroups = lazy(() =>
  import('pages/ManagerGroups').then((module) => ({
    default: module.ManagerGroups,
  }))
);

const ManagerGroupView = lazy(() =>
  import('pages/ManagerGroupsSingleGroup').then((module) => ({
    default: module.ManagerGroupsSingleGroup,
  }))
);

const ManagerAddCampaigns = lazy(() =>
  import('pages/ManagerGroupsAddCampaigns').then((module) => ({
    default: module.ManagerGroupsAddCampaigns,
  }))
);

const ManagerCreateNewGroup = lazy(() =>
  import('pages/ManagerGroupsCreateNewGroup').then((module) => ({
    default: module.ManagerGroupsCreateNewGroup,
  }))
);

const ManagerOverlapping = lazy(() =>
  import('pages/ManagerOverlapping').then((module) => ({
    default: module.ManagerOverlapping,
  }))
);

const Billing = lazy(() =>
  import('pages/ContractorBilling').then((module) => ({
    default: module.ContractorBilling,
  }))
);

const ContractorAppointments = lazy(() =>
  import('pages/ContractorAppointments').then((module) => ({
    default: module.ContractorAppointments,
  }))
);

const ContractorSales = lazy(() =>
  import('pages/ContractorSales').then((module) => ({
    default: module.ContractorSales,
  }))
);

const ContractorAuth = lazy(() =>
  import('pages/ContractorAuth').then((module) => ({
    default: module.ContractorAuth,
  }))
);

const ContractorLeads = lazy(() =>
  import('pages/ContractorLeads').then((module) => ({
    default: module.ContractorLeads,
  }))
);

const ContractorCreatePassword = lazy(() =>
  import('pages/ContractorCreatePassword').then((module) => ({
    default: module.ContractorCreatePassword,
  }))
);

const ContractorPasswordRecovery = lazy(() =>
  import('pages/ContractorPasswordRecovery').then((module) => ({
    default: module.ContractorPasswordRecovery,
  }))
);

const MyAccount = lazy(() =>
  import('pages/ContractorMyAccount').then((module) => ({
    default: module.ContractorMyAccount,
  }))
);

const ContractorCampaigns = lazy(() =>
  import('pages/ContractorCampaigns').then((module) => ({
    default: module.ContractorCampaigns,
  }))
);

const ImpersonateError = lazy(() =>
  import('pages/ImpersonateError').then((module) => ({
    default: module.ImpersonateError,
  }))
);

const FaqPage = lazy(() =>
  import('pages/ContractorFaq').then((module) => ({
    default: module.ContractorFaq,
  }))
);

export {
  Invoices,
  ManagerAddCampaigns,
  ManagerAppointments,
  ManagerAuth,
  ManagerCampaigns,
  ManagerContractors,
  ManagerCreateNewGroup,
  ManagerCreatePassword,
  ManagerGroupView,
  ManagerGroups,
  ManagerOverlapping,
  ManagerLeads,
  ManagerSales,
  ManagerPasswordRecovery,
  Billing,
  ContractorAppointments,
  ContractorAuth,
  ContractorCreatePassword,
  ContractorLeads,
  ContractorPasswordRecovery,
  MyAccount,
  ContractorCampaigns,
  ImpersonateError,
  ContractorSales,
  FaqPage,
};
